import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import CompetitionStatusForm from '../../../components/forms/CompetitionStatusForm';
import { useCompetitionStatusApi } from '../../../hooks/useCompetitionStatusApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { CompetitionStatusDTO } from '../../../services/apiClient';

const CompetitionStatusEdit: React.FC = () => {
  const { getById, edit, isLoading } = useCompetitionStatusApi();
  const [entityData, setEntityData] = useState<CompetitionStatusDTO | null>(
    null,
  );
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competition Statuses', href: '/admin/competitionstatuses' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching CompetitionStatus data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/competitionstatuses');
    } catch (error) {
      console.error('Error updating CompetitionStatus:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/competitionstatuses"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.CompetitionStatus.Edit"
    >
        {entityData ? (
          <CompetitionStatusForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/competitionstatuses')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default CompetitionStatusEdit;
